import _ from 'underscore';
import { createTheme } from '@material-ui/core';

const themeProperties = {
  overrides: {
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'inherit !important',
        },
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: '#1481F726 !important',
        },
        '&$selected': {
          backgroundColor: '#e0e0e0 !important',
        },
      },
    },
    MuiList: {
      padding: {
        paddingTop: '0px',
        paddingBottom: '0px',
      },
    },
  },
  palette: {
    primary: {
      main: '#1481f7',
      dark: '#1481f7',
    },
  },
  typography: {
    useNextVariants: true,
  },
};

export const mergeTheme = (extraThemeProperties) =>
  createTheme(_.extend(themeProperties, extraThemeProperties));

const theme = createTheme(themeProperties);
export default theme;
